<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <v-row id="analiseFaturamentoFltrosId">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashboard-filtros
                :primeiro="enablePrimeiroDia"
                :ultimo="enableUltimoDia"
                :empresas="enableEmpresa"
                :url="link"
                :supervisores="enableSupervisores"
                :areas="enableAreas"
                :redes="enableRedes"
                :classificacoes="enableClassificacao"
                :cidades="enableCidades"
                :produtos="enableProdutos"
                :linha-producao="enableLinhasProducao"
                :habilitar-filtros-data="enableFiltrosDados"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="enableBtnPrint"
            id="btnPrint"
          >
            <v-btn
              class="col-4 col-sm-3 col-md-1 col-lg-1"
              small
              :color="corPrimaria"
              dark
              :loading="imprimindo"
              @click="imprimir()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Imprimir
              <template v-slot:loader>
                <span>Imprimindo...</span>
              </template>
            </v-btn>
          </v-row>
          <v-row id="bloco1IdPrint">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-row>
                <v-col
                  id="componenteAnaliseMargem"
                  class="col-fracionado"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'413'"
                    :text="'Faturamento Bruto - R$'"
                    :texto-information="textoFaturamento"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingAnaliseMargem1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  class="col-fracionado"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'414'"
                    :text="'Volumetria (Litros)'"
                    :texto-information="textoVolume"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorVolume"
                    :padding="dynamicPaddingAnaliseMargem1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  class="col-fracionado"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'CMV'"
                    :code-information="'385'"
                    :texto-information="textoCMV"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorCMV"
                    :padding="dynamicPaddingAnaliseMargem1"
                    :loading="loadingCmv"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  class="col-fracionado"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Margem Bruta'"
                    :code-information="'386'"
                    :texto-information="textoMargemBruta"
                    :style-object="styleObject"
                    :style-object2="styleObject3"
                    :componente-valor="true"
                    :componente-valor-coluna="true"
                    :valor="`${valorMargemBruta}`"
                    :valor2="`${porcentagemMargemBruta}%`"
                    :padding="dynamicPaddingAnaliseMargem1"
                    :loading="loadingMargemBruta"
                  />
                </v-col>
                <v-col
                  id="componenteAnaliseProduto"
                  class="col-fracionado"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="3"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :text="'Margem Contribuição'"
                    :code-information="'387'"
                    :texto-information="textoMargemContribuicao"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="`${porcentagemMargemContribuicao}%`"
                    :padding="dynamicPaddingAnaliseMargem1"
                    :loading="loadingMargemContribuicao"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="bloco2IdPrint">
            <v-col
              id="componenteAnaliseMargem"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Como está a margem por Linha e Produto
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('388')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-margem-classificacao-produto />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row id="bloco3IdPrint">
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Como está a margem por Supervisor e Vendedor
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('389')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-margem-supervisor-vendedor />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row><br>
          <v-row id="bloco3IdPrint">
            <v-col
              id="componenteAnaliseProduto"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Como está a margem por Área Comercial / Cidades
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('390')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <br><br>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-margem-rede id="tableMargemRede" />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import eventEmit from '../../components/core/EventoEmit'
  import Permissao from '../../../../services/menu'
  import AnaliseMargem from '../../../../services/analisemargem2'

  export default {
    name: 'DashboardCliente',
    emits: ['setUpdateFiltros', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'showDadosTabela', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      ShowMargemClassificacaoProduto: () => import('../../components/comercial/analiseMargem2/AnaliseMargem2ClassificacaoProduto'),
      ShowMargemSupervisorVendedor: () => import('../../components/comercial/analiseMargem2/AnaliseMargem2SupervisorVendedor'),
      ShowMargemRede: () => import('../../components/comercial/analiseMargem2/AnaliseMargem2Rede'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleObject2: {
        color: localStorage.corSecondaria,
      },
      styleObject3: {
        color: localStorage.corSecondaria,
      },
      styleTexto: {
        color: '#00796B',
      },
      paginaEnable: false,
      link: window.location.href,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      area: [],
      redes: [],
      supervisor: [],
      classificacao: [],
      linhasProducao: [],
      produtos: [],
      cidades: [],
      permissaoAnaliseProduto: false,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableSupervisores: true,
      enableRedes: true,
      enableAreas: true,
      enableClassificacao: true,
      enableLinhasProducao: true,
      enableProdutos: true,
      enableCidades: true,
      enableBtn: true,
      enableBtnPrint: false,
      loadingBtnPrint: true,
      codigo: 0,
      orientacao: [],
      textoFaturamento: '',
      textoVolume: '',
      textoDesconto: '',
      textoCMV: '',
      textoMargemBruta: '',
      textoMargemContribuicao: '',
      textoClassicacaoProduto: '',
      textoSupervisorVendedor: '',
      textoCliente: '',
      codigoIds: ['384', '385', '386', '387', '388', '389', '390', '413', '414'],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dynamicPaddingAnaliseMargem1: '',
      dynamicPaddingAnaliseMargem2: '',
      enableLegenda: false,
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorVolume: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      valorCMV: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorMargemBruta: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      porcentagemMargemBruta: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      porcentagemMargemContribuicao: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      loadingFaturamento: false,
      loadingCmv: false,
      loadingMargemBruta: false,
      loadingMargemContribuicao: false,
      enableFiltrosDados: false,
      drawerFiltros: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)

      eventEmit.$on('dados-margem-total', this.handleDadosMargemTotal)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      eventEmit.$off('dados-margem-total', this.handleDadosMargemTotal)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Analise Margem')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingAnaliseMargem1 = 'padding-right: 9rem !important'

          this.dynamicPaddingAnaliseMargem2 = 'padding-right: 101rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingAnaliseMargem1 = 'padding-right: 3rem !important'

          this.dynamicPaddingAnaliseMargem2 = 'padding-right: 65rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingAnaliseMargem1 = 'padding-right: 8rem !important'

          this.dynamicPaddingAnaliseMargem2 = 'padding-right: 8rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingAnaliseMargem1 = 'padding-right: 25rem !important'

          this.dynamicPaddingAnaliseMargem2 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingAnaliseMargem1 = 'padding-right: 2.5rem !important'

          this.dynamicPaddingAnaliseMargem2 = 'padding-right: 60.4rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.area = areas
        this.redes = redes
        this.supervisor = supervisores
        this.classificacao = classificacao
        this.linhasProducao = linhasProducao
        this.produtos = produto
        this.cidades = cidade

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)

        this.primeiroDiaPrint = primeiroDia.substring(8) + '/' + primeiroDia.substring(5, 7) + '/' + primeiroDia.substring(0, 4)
        this.ultimoDiaPrint = dataFinal.substring(8) + '/' + primeiroDia.substring(5, 7) + '/' + primeiroDia.substring(0, 4)

        this.updateDate()
      },

      handleDadosMargemTotal (valorFaturamentoTotal, valorCmvTotal, valorMargemBrutaTotal, porcentagemMargemBrutaTotal, porcentagemMargemContruibuicao) {
        try {
          this.valorCMV = valorCmvTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

          this.valorMargemBruta = valorMargemBrutaTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

          if (porcentagemMargemBrutaTotal < 0) {
            this.styleObject3.color = localStorage.corError
          }

          this.porcentagemMargemBruta = porcentagemMargemBrutaTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

          this.porcentagemMargemContribuicao = porcentagemMargemContruibuicao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        } catch (error) {
          console.error('Error in handleDadosMargemTotal:', error)
        } finally {
          this.loadingCmv = false
          this.loadingMargemBruta = false
          this.loadingMargemContribuicao = false
        }
      },

      async updateDate () {
        this.enableBtnPrint = false

        eventEmit.$emit('enable-loading', true)

        eventEmit.$emit('show-dados-tabela', this.primeiroDia, this.ultimoDia, this.empresa, this.area, this.redes, this.supervisor, this.classificacao, this.linhasProducao, this.produtos, this.cidades)

        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.valorVolume = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.valorCMV = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.valorMargemBruta = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.porcentagemMargemBruta = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.porcentagemMargemContribuicao = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

        this.styleObject2.color = localStorage.corSecondaria

        this.styleObject3.color = localStorage.corSecondaria

        this.loadingFaturamento = true
        this.loadingCmv = true
        this.loadingMargemBruta = true
        this.loadingMargemContribuicao = true

        await AnaliseMargem.showAnaliseMargem2Faturamento(this.primeiroDia, this.ultimoDia, this.empresa, this.area, this.redes, this.supervisor, this.classificacao, this.linhasProducao, this.produtos, this.cidades, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = resposta.data.faturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorVolume = resposta.data.litrosFaturados.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorVolume = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Datas não conferem') {
            this.error = e.data.msg
            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, 'Empresa não encontrada')
          }
        }).finally(f => { this.loadingFaturamento = false })
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  #tableMargemRede {
    margin: -3rem 0 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    .col-fracionado {
      flex: 0 0 100%;
      max-width: 100%;
    }

    #textoFaturamentoAnaliseProduto {
      margin: 0 0 0 -4rem;
    }

    #iconInformationFatAnaliseProduto {
      margin: -6.5rem 0 0 0;
    }

    #iconInformationFatClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationKgClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationPrecoMedioClassificacao {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationFatClassificacaoMes {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationFatxFatAnterior {
      margin: -6.8rem 0 0 0;
    }

    #componenteFatLinha {
      margin: -2rem 0 -5.2rem 0;
    }

    #componenteKgTotalClassificacao {
      margin: 0 0 -5rem 0;
    }

    #componentePrecoMedioLinha {
      margin: -2rem 0 -5rem 0;
    }

    #dividirBloco1 {
      margin: -3rem 0 0 0;
    }
  }

  @media screen
  and (min-width : 600px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    .col-fracionado {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

</style>

<style lang="sass">
  .hidden
    display: none

  #textoAnaliseFaturamento
    font-size: 36px
    margin: 1.5rem 0 0 0

  #textoFaturamentoAnaliseProduto
    margin: 0 0 0 -2rem

  #btnPrint
    margin: 0.5rem 0 2rem 3rem

  #iconInformationPrecoMedioClassificacao
    maring: 0 0 0 -1rem

  #iconInformationAcumuladoAnual
    margin: 0 0 0 5rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFaturamentoGrupos
    margin: -2rem 0 0 -1rem

  #listItemMeta
    margin: -2rem 0 0 -1rem

  #componenteAnaliseMargem
    margin: -1rem 0 0 0

  #componenteAnaliseProduto
    margin: -1rem 0 0 0

  #vlrMetaAnaliseProduto
    font-size: 22px
    font-weight: bold
    margin: -3rem 0 0 0

  #textoFaturamentoClienteProduto
    margin: 0 0 0 -1rem

  #tableFatClassificacaoMes
    margin: 0 0 0 0rem

  .col-fracionado
    flex: 0 0 20%
    max-width: 20%

</style>
